import * as actions from './actions';
import * as userActions from '../user/actions';
import * as digestsSuggestionsAction from '../newsDigestsSuggestions/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    limit: 9,
    offset: 0,
    hasMore: true,
    count: 0,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const newsDigestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_NEWS_DIGESTS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case actions.SET_NEWS_DIGESTS_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case actions.SET_NEWS_DIGESTS:
            const mappedList =
                Array.isArray(action.list) && action.list.length
                    ? action.list.map((item) => ({ ...item, importanceChanged: false }))
                    : [];
            const list = state.list ? state.list.concat(mappedList) : mappedList;
            return {
                ...state,
                list: list,
                offset: action.offset,
                hasMore: action.hasMore,
                count: action.count,
                isFetching: false,
                isLoaded: true,
            };

        case actions.CLEAN_NEWS_DIGESTS:
            return initialState;

        case actions.RESET_NEWS_DIGESTS_FETCHING:
            return {
                ...state,
                isFetching: false,
            };

        case digestsSuggestionsAction.CLEAN_NEWS_DIGESTS_SUGGESTION_DATA:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 27+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 31+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/newsDigests/reducer.js